import request from "root/js/request";

export const getExpenseCategoriesCrossMP = async ({ cabinet_id, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/category/",
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const getExpenseCategoryCrossMPById = async ({ cabinet_id, category_id, ...rest }) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/category/${category_id}/`,
    method: "get",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};

export const postCreateExpenseCategoryCrossMP = async ({
  cabinet_id,
  name,
  expense_type, // 'operating', 'direct', 'other'
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/category/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: {
      name,
      expense_type,
      ...rest,
    },
  });
  return response.data;
};

export const putEditExpenseCategoryCrossMPById = async ({
  cabinet_id,
  category_id,
  name,
  expense_type,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/category/${category_id}/`,
    method: "put",
    params: {
      cabinet_id,
    },
    data: {
      name,
      expense_type,
      ...rest,
    },
  });
  return response.data;
};

export const deleteExpenseCategoryCrossMPById = async ({ cabinet_id, category_id, ...rest }) => {
  const response = await request({
    url: `/analytics/cross-mp/expense/category/${category_id}/`,
    method: "delete",
    params: {
      cabinet_id,
      ...rest,
    },
  });
  return response.data;
};
